import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Site, Currency, Entity } from '@debbie/common/dist/index.js';
import { validateNewCustomer, } from '@debbie/common/dist/customers/index.js';
import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { cases, updates } from '@debbie/cortex/dist/api/index.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups/index.js';
import { SearchInput, Panel, Button, Select, Checkbox } from '../../index.js';
import NewEntityProperties from '../../Properties/NewEntityProperties.js';
import CreateCustomer from '../../Customers/CreateCustomer.js';
import { Row, Col } from '../../Grid/index.js';
import { CaseCreationStep } from '../CaseCreator.js';
import { CreditorState } from '@debbie/common/dist/creditor/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const Create = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const selectedCreditor = useSelector((s) => s.selectedCreditor);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const tenant = useSelector(selectTenant);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const [stateCreditor, setCreditor] = useState(null);
    const [currency, setCurrency] = useState(Currency.DKK);
    const [customer, setCustomer] = useState(null);
    const [existingCustomer, setExistingCustomer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [opposition, setOpposition] = useState(false);
    const [caseGroupId, setCaseGroupId] = useState(null);
    const [properties, setProperties] = useState(null);
    const caseGroup = caseGroups && caseGroups.find((cg) => cg.id === caseGroupId);
    const creditor = allCreditors && allCreditors.find((c) => c.creditorId === stateCreditor);
    useEffect(() => {
        if (tenant) {
            setCurrency(tenant.currency);
        }
    }, [tenant]);
    useEffect(() => {
        const creditorsWithCaseGroup = allCreditors && allCreditors.filter((c) => !!c.defaultCaseGroupId);
        const creditorWithCaseGroup = creditorsWithCaseGroup &&
            creditorsWithCaseGroup.length === 1 &&
            creditorsWithCaseGroup[0]
            ? creditorsWithCaseGroup[0].creditorId
            : null;
        setCreditor(stateCreditor || selectedCreditor || creditorWithCaseGroup);
    }, [allCreditors, selectedCreditor]);
    useEffect(() => {
        if (allCreditors) {
            if (allCreditors.length === 1 && !stateCreditor) {
                setCreditor(allCreditors[0].creditorId);
            }
            else if (tenant?.type === TenantType.AccountsReceivable &&
                !stateCreditor) {
                const activeCreditors = allCreditors.filter((c) => c.state === CreditorState.Active);
                if (activeCreditors.length === 1) {
                    setCreditor(activeCreditors[0].creditorId);
                }
            }
        }
    }, [allCreditors]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, null, lang.cases.newCaseCreateExplainer),
        React.createElement(Panel, { header: lang.cases.newCaseCreate },
            Site.Client !== site && (React.createElement(Row, null,
                React.createElement(Col, { width: "12" },
                    (tenant?.type === TenantType.Agency ||
                        tenant?.type === null) && (React.createElement(SearchInput, { static: (creditor && creditor.name) || null, onRemoveStatic: () => setCreditor(null), forceOpen: true, onSelect: setCreditor, placeholder: lang.creditors.creditor, searchAll: (s) => (allCreditors
                            ? allCreditors
                                .filter((c) => [
                                CreditorState.Active,
                                CreditorState.Lead,
                                CreditorState.SignedOn,
                            ].includes(c.state))
                                .filter((c) => `${c.name}${c.centralRegisterId}${c.id}`
                                .toLowerCase()
                                .indexOf(s.toLowerCase()) !== -1 || !s)
                                .map((c) => ({
                                key: c.creditorId,
                                heading: c.name,
                                subheading: lang.creditors.states[c.state],
                                returnData: c.creditorId,
                            }))
                            : []).slice(0, 30) })),
                    React.createElement(SearchInput, { static: (caseGroup && caseGroup.label) || null, onRemoveStatic: () => setCaseGroupId(null), forceOpen: true, onSelect: setCaseGroupId, placeholder: lang.cases.caseGroup, searchAll: (s) => (caseGroups
                            ? caseGroups
                                .filter((cg) => `${cg.label}`
                                .toLowerCase()
                                .indexOf(s.toLowerCase()) !== -1 ||
                                s.length === 0)
                                .map((cg) => ({
                                key: cg.id,
                                heading: cg.label,
                                returnData: cg.id,
                            }))
                            : []).slice(0, 20) }),
                    caseGroup && (React.createElement(NewEntityProperties, { propRef: Entity.Case, scope: "case_groups", scopeId: caseGroup.id, onChange: (p) => {
                            let exists = false;
                            setProperties(properties && properties.length > 0
                                ? properties
                                    .map((prop) => {
                                    if (prop.handle === p.handle) {
                                        exists = true;
                                        return p;
                                    }
                                    else {
                                        return prop;
                                    }
                                })
                                    .concat(exists ? [] : [p])
                                : [p]);
                        } }))))),
            React.createElement("h3", null, lang.financials.currency),
            React.createElement(Select, { value: currency, onChange: (e) => {
                    const val = e.target.value;
                    if (val && Object.values(Currency).includes(val)) {
                        setCurrency(val);
                    }
                } }, Object.values(Currency).map((currency) => (React.createElement("option", { key: currency, value: currency }, currency))))),
        React.createElement(Panel, { header: lang.customers.parties },
            React.createElement(CreateCustomer, { onChange: (customer) => {
                    setCustomer(customer);
                }, onChangeExistingCustomer: (existingCustomer) => {
                    setExistingCustomer(existingCustomer);
                }, creditorId: creditor ? creditor.creditorId : null }),
            React.createElement("br", null),
            React.createElement(Checkbox, { checked: opposition, onChange: (e) => setOpposition(e.target.checked), placeholder: lang.cases.debtorHaveObjections, style: { marginBottom: '0px' } })),
        React.createElement("div", null,
            React.createElement(Button, { loading: loading, disabled: !(stateCreditor !== null &&
                    (existingCustomer || validateNewCustomer(customer))), onClick: async () => {
                    setLoading(true);
                    try {
                        let _customerId = existingCustomer?.customerId;
                        if (!_customerId && customer) {
                            const newCustomer = await customersAPI.create(stateCreditor, customer);
                            _customerId = newCustomer.customerId;
                        }
                        if (!_customerId) {
                            throw 'Failed creating customer';
                        }
                        if (!existingCustomer && !customer) {
                            throw 'No customer added';
                        }
                        if (!stateCreditor) {
                            throw 'Creditor not defined';
                        }
                        const created = await cases.create({
                            customerId: _customerId,
                            creditorId: stateCreditor,
                            caseVouchers: [],
                            currency,
                            groupId: caseGroupId || undefined,
                            properties: properties || undefined,
                        });
                        if (opposition) {
                            await updates.make({
                                referenceId: created.id,
                                updateTypeId: UpdateType.OPPOSITION,
                            });
                        }
                        c.customers.getById(_customerId);
                        c.redirect.redirect(props.genLink(created.id, CaseCreationStep.Economy));
                    }
                    catch (error) {
                        console.log(error);
                        alert('Error');
                    }
                    setLoading(false);
                } }, lang.misc.create))));
};
export default Create;
//# sourceMappingURL=Create.js.map